import React from 'react';
import StoreForm from './form';
import {getStoreItem, updateStoreItem} from '../../modules/Api';
import {normalizer, prepareForEdit} from './pipeline';
import {notification} from 'antd';
import history from "../../modules/History";

class EditStore extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }
        
    }
    componentDidMount() {
        this.fetchStoreDetail();
    }
    fetchStoreDetail() {
        const storeId = this.props.match.params.id;
        getStoreItem(storeId, data => {this.setState({data: prepareForEdit(data)})});
    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const storeId = this.props.match.params.id;
        const formData = normalizer(values);
        updateStoreItem(storeId, formData, () => {
            notification.open({
                message: `فروشگاه با موفقیت ویرایش شد!`,
                description: ``
            });
            this.setState({submitted: false});
            history.item.push(`/stores`);
        })
    }
    render() {
        return (<div><StoreForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default EditStore;


// WEBPACK FOOTER //
// ./src/containers/Stores/edit.js